var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3204 1.59799C13.1084 0.379099 14.8916 0.379101 15.6796 1.598L19.0541 6.81774C19.324 7.23518 19.7396 7.53716 20.22 7.66482L26.227 9.26118C27.6298 9.63396 28.1808 11.3298 27.2651 12.4559L23.3436 17.2783C23.03 17.6639 22.8712 18.1525 22.8983 18.6489L23.2363 24.8552C23.3152 26.3045 21.8727 27.3526 20.5187 26.8297L14.7206 24.5903C14.2569 24.4112 13.7431 24.4112 13.2794 24.5903L7.4813 26.8297C6.12735 27.3526 4.68475 26.3045 4.76369 24.8552L5.10175 18.6489C5.12878 18.1525 4.97002 17.6639 4.65641 17.2783L0.734919 12.4559C-0.180814 11.3298 0.37021 9.63396 1.77296 9.26118L7.78001 7.66482C8.26041 7.53716 8.67605 7.23518 8.94592 6.81774L12.3204 1.59799Z",
    fill: "#FAD247"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.b6f967f6.svg";
export { ForwardRef as ReactComponent };